module.exports = __webpack_public_path__ + "static/img/goBack.c962d39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/goBack.png
// module id = K+1U
// module chunks = 1